export default function extractNamesFromEmail(email) {
    const regex = /^([a-zA-Z]+)\.([a-zA-Z]+)@/;
    const match = email.match(regex);

    if (match) {
        const firstName = match[1];
        const lastName = match[2];

        // Capitalize the first letter of each name and return them as a single string
        const formattedFirstName = firstName.charAt(0).toUpperCase() + firstName.slice(1);
        const formattedLastName = lastName.charAt(0).toUpperCase() + lastName.slice(1);

        return `${formattedFirstName} ${formattedLastName}`;
    } else {
        return null;
    }
}